const routes = {
  '/app/team': {
    fetch: () =>
      import(/* webpackChunkName: 'team-route' */ 'app/team/asyncRoute').then(
        module => module.default
      ),
  },
  '/app/join-team': {
    fetch: () =>
      import(
        /* webpackChunkName: 'join-team-route' */ 'app/team/joinTeamAsyncRoute'
      ).then(module => module.default),
  },
  '/teams': {
    fetch: () =>
      import(
        /* webpackChunkName: 'teams-landing-route' */ 'app/team/teamsLandingAsyncRoute'
      ).then(module => module.default),
  },
};

export default routes;
